const updateForCreated = function ({ list, item, limit, currentPage }) {
  if (limit && currentPage) {
    if (list?.length >= 0 && item?.id) {
      list.splice(limit * (currentPage - 1), 0, item);
    }
  } else {
    if (list?.length >= 0 && item?.id) {
      list.unshift(item);
    }
  }

  return [...list];
};

const updateForUpdated = function (list, item) {
  if (list?.length > 0 && item?.id) {
    const findIndex = list.findIndex((e) => e.id === item.id);
    if (findIndex > -1) {
      list[findIndex] = { ...list[findIndex], ...item };
    }
  }

  return [...list];
};

const updateForDeleted = function (list, item) {
  if (list?.length > 0 && item?.id) {
    const findIndex = list.findIndex((e) => e.id === item.id);
    if (findIndex > -1) {
      list.splice(findIndex, 1);
    }
  }

  return [...list];
};

export { updateForCreated, updateForUpdated, updateForDeleted };
